import { api } from 'services';

export default {
  listArea() {
    return api.get(`/fees/list_areas`);
  },
  listTransportFee() {
    return api.get('/fees/transport_fees');
  },
  publishDelivery(payload) {
    return api.post('/fees/delivery_fees', payload);
  },
  updateDelivery(payload, id) {
    return api.put(`/fees/delivery_fees/${id}`, payload);
  },
  deliveryFees() {
    return api.get('/fees/delivery_fees');
  },
  createTransportFee(payload) {
    return api.post('/fees/transport_fees', payload);
  },
  listProvince() {
    return api.get('/fees/provinces');
  },
  listCitiesOfProvince(provinceId) {
    return api.get(`/fees/provinces/${provinceId}`);
  },
};
